import { FieldProps, FormControl, useFormField } from '@core/utils/form';
import FormHelperText from '@mui/material/FormHelperText';

import React, { Fragment, useEffect } from 'react';
import { FormGroup, Label } from 'reactstrap';
import { DatePicker } from 'antd';
import type { Moment } from 'moment';
import momentGenerateConfig from 'rc-picker/lib/generate/moment';
const MomentDatePicker = DatePicker.generatePicker<Moment>(momentGenerateConfig);

import './form_date.scss';
import { toMoment } from '@core/utils/time';
import { R } from '@core/utils/r';

export interface FormDateTimeInputProps extends FieldProps<FormControl<number> | FormControl<number | null>> {
  onChange?(date: number | null): void;
  withoutGroup?: boolean;
  asterisk?: boolean;
  clearable?: boolean;
  disabledDate?(current: Moment): boolean;
}

export function FormDateTimeInput(props: FormDateTimeInputProps) {
  const { disabledDate } = props;
  const { formControl, fieldState, fieldConfig } = useFormField(props);
  const fieldTouched = (fieldState && fieldState.touched) || formControl.inheritedSubmitted || false;
  const fieldValue = fieldState.value ? toMoment(fieldState.value) : toMoment();
  const fieldError = (fieldTouched && fieldState.errorMessage) || null;

  const onChange = (value: Moment, dateString: [string, string] | string) => {
    if (value) {
      formControl.setValue(value.unix());
      props.onChange && props.onChange(value.unix());
    } else {
      formControl.setValue(null);
      props.onChange && props.onChange(null);
    }
  };

  useEffect(() => {
    if (R.isNull(fieldState.value)) {
      formControl.setValue(toMoment().unix());
    }
  }, [fieldState.value, formControl]);

  const content = (
    <Fragment>
      {fieldConfig.label && (
        <Label for={formControl.uid}>
          {fieldConfig.label} {fieldConfig.required && props.asterisk && <span className="text-danger">*</span>}
        </Label>
      )}
      <MomentDatePicker
        showTime={{ format: 'HH:mm', minuteStep: 15 }}
        format={'MM/DD/YYYY hh:mma'}
        use12Hours
        value={fieldValue}
        allowClear={props.clearable || false}
        popupStyle={{ zIndex: 9999 }}
        onChange={onChange}
        disabledDate={disabledDate}
      />
      {!!fieldError && (
        <FormHelperText className="mui-error" style={{ color: '#f44336' }}>
          {fieldError}
        </FormHelperText>
      )}
    </Fragment>
  );

  if (props.withoutGroup) {
    return <div className="theme_date-picker d-flex flex-column">{content}</div>;
  }

  return <FormGroup className="theme_date-picker d-flex flex-column">{content}</FormGroup>;
}
